import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import StaffingCatalogSelect from "components/StaffingLevels/StaffingCatalogSelect";
import { filterCatalog } from "components/StaffingLevels/staffingNeedGrid";

let nextCatalogId = 0;

const CatalogMultiSelect = ({
	label,
	items,
	selected,
	onToggleItem,
	onClear,
	chipOf,
	labelOf,
	searchPlaceholder,
	invalid,
	error,
}) => {
	const { t } = useTranslation();
	const idRef = useRef(null);
	if (idRef.current == null) {
		nextCatalogId += 1;
		idRef.current = `c${nextCatalogId}`;
	}
	const catalogId = idRef.current;
	const [open, setOpen] = useState(false);
	const [query, setQuery] = useState("");

	useEffect(() => {
		if (!open) return undefined;
		const onDown = (event) => {
			const target = event.target;
			if (
				target &&
				target.closest &&
				target.closest(`[data-sl-catalog="${catalogId}"]`)
			) {
				return;
			}
			setOpen(false);
			setQuery("");
		};
		document.addEventListener("mousedown", onDown);
		return () => document.removeEventListener("mousedown", onDown);
	}, [open, catalogId]);

	const list = items || [];
	const chosen = selected || [];
	const missing = chosen.filter(
		(item) => !list.some((entry) => entry.id === item.id)
	);
	const catalog = missing.length ? [...list, ...missing] : list;
	const visible = filterCatalog(
		catalog,
		chosen,
		open ? query : "",
		labelOf
	);

	return (
		<div className="catalog-multi-select">
			<StaffingCatalogSelect
				catalogId={catalogId}
				label={label}
				items={visible}
				selected={chosen}
				open={open}
				query={open ? query : ""}
				catalogEmpty={catalog.length === 0}
				invalid={invalid}
				onToggleOpen={() => {
					setOpen((current) => !current);
					setQuery("");
				}}
				onQuery={setQuery}
				onToggleItem={onToggleItem}
				onClear={onClear}
				chipOf={chipOf}
				searchPlaceholder={searchPlaceholder}
				emptyLabel={t("common.catalog.empty")}
				noMatchesLabel={t("common.catalog.noMatches")}
				selectedLabel={t("common.catalog.selectedCount", {
					count: chosen.length,
				})}
				clearLabel={t("common.catalog.clearSelection")}
			/>
			{error ? <div className="invalid-feedback d-block">{error}</div> : null}
		</div>
	);
};

export function catalogChip(item, label, removeLabel) {
	const color = item && (item.background_color || item.color);
	return {
		label,
		style: color ? { backgroundColor: color, color: "#0d0a2c" } : undefined,
		removeLabel,
	};
}

export default CatalogMultiSelect;
